export default __webpack_public_path__ + "static/media/close.c1c4e9c1.svg";